import React from 'react';
import { Box } from '@mui/material';
import AnimatedTitle from '../common/AnimatedTitle';

const MobileHeroSection = ({ salon }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: 280,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(salon.photos && salon.photos.length > 0 
          ? {
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("${salon.photos[0]}")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }
          : {
              background: 'linear-gradient(135deg, #F5F5DC 0%, #E8E8D0 30%, #D6D3D1 70%, #000000 100%)'
            }
        )
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          px: 3,
          py: 2
        }}
      >
        <AnimatedTitle
          variant="h3"
          sx={{ 
            mb: 1,
            fontSize: { xs: '1.75rem', sm: '2rem' },
            filter: salon.photos && salon.photos.length > 0 
              ? 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5))'
              : 'drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3))'
          }}
          isMobile={true}
        >
          {salon.salonName}
        </AnimatedTitle>
      </Box>
    </Box>
  );
};

export default MobileHeroSection;